import React from 'react'
import {Button, Popconfirm} from "antd";
import {deleteProduction, changeClosedStatus} from "../../services/serviceProduction";
import ProductionUpdate from "./ProductionUpdate";
import ProductionDetail from "./ProductionDetail";

const ProductionActions = ({record, updater}) => {

    const handleDeleteClick = () => {
        deleteProduction(record.id)
            .then(() => updater())
    }

    const handleCloseClick = () => {
        changeClosedStatus({id: record.id, closed: true})
            .then(() => updater())
    }

    return(
        <React.Fragment>
            <ProductionUpdate productionItem={record} updater={updater} />
            <ProductionDetail productionItem={record} updater={updater} />
            <Popconfirm
                title={'Bu Üretimi Kapatmak İstediğinize Emin misiniz ?'}
                okText={'Onayla'}
                cancelText={'VAZGEÇ'}
                okButtonProps={{type: 'primary'}}
                onConfirm={handleCloseClick}
            >
                <Button
                    type={'link'}
                    disabled={record.closed}
                >
                    Üretimi Kapat
                </Button>
            </Popconfirm>
            <Popconfirm
                title={'Silmek istediğinize emin misiniz ?'}
                okText={'SİL'}
                cancelText={'VAZGEÇ'}
                okButtonProps={{type: 'danger'}}
                onConfirm={handleDeleteClick}
            >
                <Button type={"link"} danger>
                    Sil
                </Button>
            </Popconfirm>
        </React.Fragment>
    )
}
export default ProductionActions